import { $, _, Backbone, Foundation, Radio, moment, Datepicker } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import Notification from "../../utils/Notification";

import User from "../../models/User";
//import Client from '../../models/Client'

import PricediscountsSidebarTpl from "../../templates/pricediscounts/PricediscountsSidebarTpl.html";

export default InboomaBaseView.extend({
  /* TODO: All that this._updateNotification(); should be called by collection,
           as an "collection:changed" event
  */

  template: PricediscountsSidebarTpl,
  el: "#inb-c-sidebar",
  templateContext() {
    return {
      _,
      moment,
    };
  },

  _filterCountNotification: {},
  _collectionEmptyNotification: {},

  ui: {},

  events: {},

  initialize() {
    this.render();
  },

  onRender() {
    /*const that = this;

    new Foundation.Dropdown(this.getUI('dropdown'))

    // @todo Bug: When toggling offcanvasform and going back,
    // datepicker click events have been lost
    this.datepickerStart = new Datepicker({

      field : that.getUI('dateStartField')[0],
      trigger : that.getUI('dateStartField')[0],
      defaultDate : new Date(),

      onSelect : (date) => {

        that.datepickerEnd.setMinDate(moment(date).add(1,'day').toDate());
        that.getUI('flistDateCondition').find('.active').removeClass('active');
        that.getUI('flistNextAppointments').find('.active').removeClass('active');
        that.getUI('dateStartField').addClass('active').find('span').html(' - '+ moment(date).format('D. MMMM YYYY'));
        that.collection.filterDateBeginBiggerThan(moment(date).format('X'));
        that._updateNotification();        

      }

    });

    /*this.datepickerEnd = new Datepicker({

      field : that.getUI('dateEndField')[0],
      defaultDate : new Date(),

      onSelect : (date) => {

        that.getUI('flistDateCondition').find('.active').removeClass('active');
        that.getUI('flistNextAppointments').find('.active').removeClass('active');
        that.getUI('dateEndField').addClass('active').find('span').html(' - '+moment(date).format('D. MMMM YYYY'));
        that.collection.filterDateEndSmallerThan(moment(date).format('X'));
        that._updateNotification();        

      }
    });*/
  },
});
